export enum PageOption {
  DealerOverview = 'DealerOverview',
  FleetOverview = 'FleetOverview',
  FleetHealth = 'FleetHealth',
  FleetPerformance = 'FleetPerformance',
  Orbit = 'Orbit',
}

export enum FleetDataModel {
  ROBOT = 'cloud.Robot',
  MISSION = 'cloud.Mission',
  ORGANIZATION = 'cloud.Organization',
  ERROR = 'robot.Error',
  ROBOT_HEALTH = 'robot.Health',
}

/** How a robot's health colour moved over a window. Mirrors the backend HealthDirection. */
export enum HealthDirection {
  DETERIORATED = 'DETERIORATED',
  RECOVERED = 'RECOVERED',
  WENT_DARK = 'WENT_DARK',
  UNCHANGED = 'UNCHANGED',
  /** Not held by the reported organization when the window opened. */
  JOINED = 'JOINED',
}

export enum MissionCodeType {
  ERROR = 'ERROR',
  MAINTENANCE = 'MAINTENANCE',
}

export enum FieldType {
  STRING = 'STRING',
  NUMBER = 'NUMBER',
  STRING_LIST = 'STRING_LIST',
  DATE = 'DATE',
  BOOL = 'BOOL',
}

export enum FilterType {
  EXACT = 'EXACT',
  I_EXACT = 'I_EXACT',
  CONTAINS = 'CONTAINS',
  I_CONTAINS = 'I_CONTAINS',
  STARTS_WITH = 'STARTS_WITH',
  ENDS_WIDTH = 'ENDS_WIDTH',
  REGEX = 'REGEX',
  I_REGEX = 'I_REGEX',
  IN = 'IN',
  IS_NULL = 'IS_NULL',
  GT = 'GT',
  GTE = 'GTE',
  LT = 'LT',
  LTE = 'LTE',
  RANGE = 'RANGE',
  YEAR = 'YEAR',
  MONTH = 'MONTH',
  DAY = 'DAY',
}

export enum FleetWidgetType {
  TEXT = 'TEXT',
  TABLE = 'TABLE',
  CARD = 'CARD',
  BAR_CHART = 'BAR_CHART',
  PIE_CHART = 'PIE_CHART',
  LINE_CHART = 'LINE_CHART',
  CUMULATIVE_CHART = 'CUMULATIVE_CHART',
}

export enum BucketSize {
  WEEK = 'WEEK',
  MONTH = 'MONTH',
  YEAR = 'YEAR',
}

export enum FilterOperation {
  MAX = 'MAX',
  MIN = 'MIN',
  SUM = 'SUM',
  AVG = 'AVG',
  COUNT = 'COUNT',
  FIRST = 'FIRST',
  LAST = 'LAST',
}

export enum MissionDateFilter {
  MONTH = 'MONTH',
  WEEK = 'WEEK',
  DAY = 'DAY',
  CUSTOM = 'CUSTOM',
}
